import React, { Dispatch } from "react";
import { Updater } from "use-immer";

import { IgTextField, IgTypography } from "@intelligems/ig-theme";
import { StripeApiPriceTemplateDto } from "@intelligems/ig-types";
import { Skeleton } from "@mui/material";
import { VirtualAutoComplete } from "@src/components/VirtualAutoComplete/VirtualAutoComplete";
import { filterByNameOrId } from "@src/features/admin/components/Fields/filter-by-name-or-id";
import {
  CreateOrModifySubscriptionReducerType,
  CreateSubscriptionReducerAction,
} from "@src/features/admin/pages/overview/components/Drawers/SubscriptionDrawer/subscriptionReducer";

const Formatter = (data: StripeApiPriceTemplateDto) => {
  return <IgTypography variant={"body2"}>{data.name}</IgTypography>;
};

interface ChoosePriceTemplateFieldProps {
  template: StripeApiPriceTemplateDto | null;
  setTemplate: Updater<StripeApiPriceTemplateDto | null>;
  templates: StripeApiPriceTemplateDto[] | undefined;
  payload: CreateOrModifySubscriptionReducerType;
  dispatchPayload: Dispatch<CreateSubscriptionReducerAction>;
}

export const ChoosePriceTemplateField = ({
  template,
  setTemplate,
  payload,
  dispatchPayload,
  templates,
}: ChoosePriceTemplateFieldProps) => {
  if (!templates) {
    return <Skeleton variant="rectangular" height={40} />;
  }

  return (
    <VirtualAutoComplete
      sx={{
        "& .MuiInputBase-root": {
          height: "40px",
          fontSize: "12px",
        },
      }}
      componentsProps={{
        popper: { sx: { zIndex: 1800 } },
      }}
      formatter={Formatter}
      onChange={(e, newValue: StripeApiPriceTemplateDto) => {
        setTemplate(newValue);
      }}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      options={templates}
      getOptionLabel={(option: StripeApiPriceTemplateDto) => option.name}
      renderInput={(params) => <IgTextField {...params} variant={"standard"} />}
      value={template}
      filterOptions={filterByNameOrId}
    />
  );
};
